import { render } from "./DbsTickBornePopover.vue?vue&type=template&id=f69f53da&scoped=true"
const script = {}

import "./DbsTickBornePopover.vue?vue&type=style&index=0&id=f69f53da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69f53da"]])

export default __exports__